import { PricesResendManager } from "../classes/pricesResendManager";
import { DATA_PRODUCER_WORKSHEET_NAME } from "../service/globalValues";
import PostHogService from "../service/PostHogService";
import { sendValues } from "../service/producerServices";
import {
  DEFAULT_BUTTON_TO_RETRY_TEXT,
  ENABLED_BUTTON_TO_UPDATE_TEXT,
  ROW_ID_COLUMN,
  UPDATE_BUTTON_COLUMN,
} from "../service/producerServices/constants";
import { OnSingleClickedArgs } from "./types";
import * as Sentry from "@sentry/react";

export const onSingleClicked = async ({ event, uploadData }: OnSingleClickedArgs) => {
  if (event.address.charAt(0) !== UPDATE_BUTTON_COLUMN) return;

  try {
    await Excel.run(async (context) => {
      const worksheet = context.workbook.worksheets.getItemOrNullObject(DATA_PRODUCER_WORKSHEET_NAME);
      const actionButton = worksheet.getRange(event.address);
      const securityId = worksheet.getRange(ROW_ID_COLUMN + event.address.substring(1));

      actionButton.load("values");
      securityId.load("values");
      await context.sync();

      if (actionButton.values[0][0] === DEFAULT_BUTTON_TO_RETRY_TEXT) {
        PricesResendManager.getInstance().tryToResendErrorThatCantBeSent({
          securityProducerId: securityId.values[0][0],
        });
      } else if (actionButton.values[0][0] === ENABLED_BUTTON_TO_UPDATE_TEXT) {
        await sendValues({
          context,
          clickedCell: event.address,
          onUploadData: uploadData,
        });

        PostHogService.capture('manual_price_update', {
          security_id: securityId.values[0][0],
          component: 'data_producer_sheet',
        });
      }
    });
  } catch (error) {
    console.log("Error while handling onSingleClicked event", error);

    Sentry.captureException({
      message: "Error while handling onSingleClicked event",
      level: "error",
      data: error,
    });
  }
};
